var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGSheet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39062 0C3.07812 0 2.04688 1.07812 2.04688 2.39062V27.6094C2.04688 28.9219 3.07812 30 4.39062 30H25.8594C27.1719 30 28.25 28.9219 28.25 27.6094V9.51562L19.3906 0H4.39062V0Z",
    fill: "#20A971"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73438 17.5781V25.2656H16.8125V17.5781H6.73438ZM9.78125 24.6094H7.4375V22.9688H9.78125V24.6094ZM7.4375 22.2656H9.78125V20.625H7.4375V22.2656ZM9.78125 19.9219H7.4375V18.2344H9.78125V19.9219ZM10.4375 24.6094H16.1562V22.9688H10.4375V24.6094ZM16.1562 22.2656H10.4375V20.625H16.1562V22.2656ZM10.4375 19.9219H16.1562V18.2344H10.4375V19.9219Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 9.51562V9.98438H22.25C22.25 9.98438 19.2969 9.42188 19.3906 6.84375C19.3906 6.84375 19.4844 9.51562 22.2031 9.51562H28.25Z",
    fill: "#189355"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M19.3906 0V6.79688C19.3906 7.59375 19.9062 9.51562 22.25 9.51562H28.25L19.3906 0Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGSheet);
export default __webpack_public_path__ + "static/media/G-Sheet.e492e0a24c526fe2337cf7bbf44d59ad.svg";
export { ForwardRef as ReactComponent };